import * as React from "react";
import { Context } from "./_context";
export const CategoryShoppingCenterIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M21.102 3.005A1 1 0 0 1 22 4v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-9l.005-.102A1 1 0 0 1 3 10h13l.102.005A1 1 0 0 1 17 11v8h3V5H9v3H7V4l.005-.103A1 1 0 0 1 8 3h13l.102.005ZM4 19h11v-7H4v7Z", fill: "currentColor" }));
  return iconset[size];
};
CategoryShoppingCenterIcon.iconId = "5jd9Mo";
